<div
  class="tournament-info-card"
  [ngClass]="[variant(), isDisabled() ? 'disabled' : '']"
  [ngStyle]="cardStyle() | theme"
>
  @if (splicedBg && variant() === "full") {
    <app-spliced-background
      [image]="splicedBg.imageUrl"
      [cornerSize]="splicedBg.cornerSize"
      [disabled]="isDisabled()"
    />
  }
  @if (showButtons()) {
    <button class="question-icon" (click)="onTutorialClick()">
      <app-icon icon="question-circle" [colorCss]="iconInfoColor" sizeCss="--icon-medium" />
    </button>
  }

  <app-tournament-pill [tournamentLabel]="pillLabel()" [state]="activeState()" />

  <div class="info-titles">
    <div [ngStyle]="prizePoolLabelStyles | theme">
      {{ prizePoolLabel }}
    </div>
    <div class="prize-container">
      @if (totalPrizePool().icon && totalPrizePool().iconPosition === "start") {
        <app-currency-icon [icon]="totalPrizePool().icon!" sizeCss="--icon-medium" />
      }
      <div class="prize-stack">
        @if (hasPrizeShadow()) {
          <div [ngStyle]="prizePoolShadowStyles() | theme" class="prize-shadow">
            {{ totalPrizePool().text }}
          </div>
        }
        <div [ngStyle]="prizePoolValueStyles() | theme" class="prize-text">
          {{ totalPrizePool().text }}
        </div>
      </div>
      @if (totalPrizePool().icon && totalPrizePool().iconPosition === "end") {
        <app-currency-icon [icon]="totalPrizePool().icon!" sizeCss="--icon-medium" />
      }
    </div>
    @if (status() === "FINISHED") {
      @if (ctaResult()) {
        <div [ngStyle]="ctaResultStyles | theme">
          {{ ctaResult() }}
        </div>
      }
    } @else if (status() === "COLLECTING_SCORES") {
      <div [ngStyle]="ctaStyles | theme">
        {{ collectingScoresCta }}
      </div>
    } @else {
      <div [ngStyle]="ctaStyles | theme">
        {{ cta }}
      </div>
    }
  </div>

  <div class="info-items">
    @for (config of infoItems(); track config.label) {
      <app-tournament-info-item [config]="config" />
    }
  </div>

  @if (showButtons()) {
    <div class="buttons">
      <app-button
        [label]="resultsButtonLabel"
        variant="secondary"
        stretch="fill"
        (clickEvent)="onViewClick()"
        class="button-secondary"
      />
      @if (activeState() === "active") {
        <app-button
          [label]="playButtonLabel()"
          [primaryAmount]="playButtonAmount()"
          variant="primary"
          stretch="fill"
          [disabled]="paymentInFlight()"
          (clickEvent)="onPlayClick()"
          class="button-primary"
        />
      }
    </div>
  }
</div>
